import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import api from '../../api/api'

export const place_order = createAsyncThunk(
  'order/place_order',
  async ({
    price,
    products,
    shipping_fee,
    items,
    shippingInfo,
    userId,
    createdAt,
    orderNote,
    paymentMethod,
  }) => {
    try {
      const { data } = await api.post('/home/order/place-order', {
        price,
        products,
        shipping_fee,
        items,
        shippingInfo,
        userId,
        createdAt,
        orderNote,
        paymentMethod,
      })

      // ✅ Return this to be used in .fulfilled reducer
      return data
    } catch (error) {
      console.log(error?.response || error)
      // Optionally: throw the actual error message
      throw error.response?.data || error
    }
  }
)
// End Method

export const get_orders = createAsyncThunk(
  'order/get_orders',
  async ({ customerId, status }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(
        `/home/coustomer/get-orders/${customerId}/${status}`
      )
      // console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const delete_orders = createAsyncThunk(
  'order/delete_orders',
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.delete(`/home/coustomer/delete-orders`)
      // console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const get_order_details = createAsyncThunk(
  'order/get_order_details',
  async (orderId, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(
        `/home/coustomer/get-order-details/${orderId}`
      )
      // console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const get_customer_dashboard_data = createAsyncThunk(
  'order/get_customer_dashboard_data',
  async (customerId, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(
        `/home/coustomer/get-dashboard-data/${customerId}`
      )
      // console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

// export const order_confirm = createAsyncThunk(
//   'order/order_confirm',
//   async ({ orderId, paymentMethod }, { rejectWithValue, fulfillWithValue }) => {
//     try {

//       const { data } = await api.put(
//         `/order/confirm/${orderId}`,
//         { paymentMethod },
//         { withCredentials: true }
//       )
//       return fulfillWithValue(data)
//     } catch (error) {
//       return rejectWithValue(error.response.data)
//     }
//   }
// )
// End Method

export const orderReducer = createSlice({
  name: 'order',
  initialState: {
    myOrders: [],
    errorMessage: '',
    successMessage: '',
    myOrder: {},

     recentOrders: [],
     totalOrder: 0,
    pendingOrder: 0,
    deliveredOrder: 0,
  },
  reducers: {
    messageClear: (state, _) => {
      state.successMessage = null
      state.errorMessage = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(place_order.fulfilled, (state, { payload }) => {
        state.successMessage = payload.message
      })
      .addCase(place_order.rejected, (state, { payload }) => {
        state.errorMessage = payload.error
        state.loader = false
      })
      .addCase(get_orders.fulfilled, (state, { payload }) => {
        state.myOrders = payload.orders
      })
      .addCase(delete_orders.fulfilled, (state, { payload }) => {
        state.loader = false
        state.successMessage = payload.message
      })
      .addCase(get_order_details.fulfilled, (state, { payload }) => {
        state.myOrder = payload.order
      })
      .addCase(get_customer_dashboard_data.fulfilled, (state, { payload }) => {
              state.totalOrder = payload.totalOrder
              state.pendingOrder = payload.pendingOrder
              state.deliveredOrder = payload.deliveredOrder
              state.recentOrders = payload.recentOrders
            })
    // .addCase(order_confirm.rejected, (state, { payload }) => {
    //   state.errorMessage = payload.message
    // })
    // .addCase(order_confirm.fulfilled, (state, { payload }) => {
    //   state.successMessage = payload.message
    // })
  },
})
export const { messageClear } = orderReducer.actions
export default orderReducer.reducer
